import React from "react";
import { SignIn as ClerkSignIn } from "@clerk/clerk-react";

export const SignIn: React.FC = () => {
  return (
    <div className="h-full flex items-center justify-center py-12">
      <div className="w-full max-w-md px-4 sm:px-6 lg:px-8">
        <ClerkSignIn 
          signUpUrl="/signup"
          appearance={{
            elements: {
              formButtonPrimary: 'bg-indigo-600 hover:bg-indigo-700 text-white',
              card: 'shadow-lg rounded-lg',
            }
          }}
        />
      </div>
    </div>
  );
};
